import { Panel } from "./Panel";
import { LoadContext } from "../../../utils";
import { Focusable, InteractiveWrapper, Switch } from '../../../ui';
import {
    Sprite,
} from "pixi.js";
import { Game } from "../../../game";

export class AudioDescription extends Panel
{
    private switch:Switch;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( game:Game )
    {
        super(
            game,
            "Audio Description",
            {
                title: "CYB_Panel1_AudioDescription",
                explain: 'CYB_Panel_AD_Explanation',
                settings: 'CYB_Panel_AD_Settings',
            },
            {width:650, height:217}
        );

        const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_audiodesc']);
        icon.position.set( this.icon_x, this.icon_y );
        this.addChild( icon );

        this.switch = new Switch();
        this.switch.position.set( 270, 135 );
        this.updateToMatchSetting();
        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.settings.playAudioDescriptions.value = newValue;
            const eventName: string = newValue ? "audio_description_on" : "audio_description_off";
            this.game.logEvent("change_setting", eventName);
            let prom = this.playSwitchVO( this.switch );
            if( prom && newValue ) {
                prom.then( ()=>{
                    this.emit( "turnedOn" );
                });
            }
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.playSwitchHover( this.switch );
            },
            onFocus: () => {
                this.playSwitchHover( this.switch, true );
            },
            onTap: () => {}
        }));
        this.addChild( this.switch );
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [this.switch] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.switch.isOn = this.settings.playAudioDescriptions.value;
    }

    destroy()
    {
        super.destroy();
    }
}